var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:_vm.classes},[(_vm.tooltipTitle)?_c('a-tooltip',{attrs:{"tip":_vm.tooltipTitle,"discreet":true}},[_vm._v(" "+_vm._s(_vm.formattedDate)+" ")]):_c('span',[_vm._v(_vm._s(_vm.formattedDate))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }